import { Store, ActionContext, ActionHandler } from 'vuex';
import { cloneDeep } from '~/components/utils/core/object';

export function withRollback<S, R>(action: ActionHandler<S, R>, mutationName = 'updateState') {
  return async function wrappedAction(this: Store<R>, context: ActionContext<S, R>, payload?: unknown) {
    const snapshot = cloneDeep(context.state);

    try {
      await action.call(this, context, payload);
    } catch (e) {
      context.commit(mutationName, snapshot);
      throw e;
    }
  };
}
